import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {InhaberEntitiesActions, mappedHttpErrorResponseOperator} from '@adnova/jf-ng-components';
import {catchError, filter, map, switchMap} from 'rxjs/operators';
import {MengeneinheitService} from '../../openapi/fakturierung-openapi';
import {MengeneinheitEntitiesActions} from '../actions/mengeneinheit-entities.actions';
import {exhaustMap, of, take} from 'rxjs';
import {MengeneinheitExtended} from '../../interfaces/mengeneinheit-extended.interface';
import {Store} from '@ngrx/store';
import {AppState} from '../states/app.state';
import {MengeneinheitEntitiesSelectors} from '../selectors/mengeneinheit-entities.selectors';
import {NGXLogger} from 'ngx-logger';


@Injectable()
export class MengeneinheitEntitiesEffects {
  private _actions$ = inject(Actions);
  private _mengeneinheitService = inject(MengeneinheitService);
  private _store = inject(Store<AppState>);
  private _logger = inject(NGXLogger);

  readonly setCurrentInhaberIdFromURL$ = createEffect(
    () => this._actions$.pipe(
      ofType(InhaberEntitiesActions.setCurrentInhaberIdFromURL),
      map(action => action.currentInhaberId),
      filter((currentInhaberId): currentInhaberId is string => !!currentInhaberId),
      map(currentInhaberId => MengeneinheitEntitiesActions.readMengeneinheit({betriebId: currentInhaberId})),
    ),
  );

  readonly readMengeneinheit$ = createEffect(() =>
    this._actions$.pipe(
      ofType(MengeneinheitEntitiesActions.readMengeneinheit),
      exhaustMap(action =>
        this._store.select(MengeneinheitEntitiesSelectors.mengeneinheitenByBetrieb(action.betriebId)).pipe(
          take(1),
          map(existingEntities => ({existingEntities, betriebId: action.betriebId}))
        )
      ),
      filter(({existingEntities}) => existingEntities.length === 0),
      switchMap(({betriebId}) =>
        this._mengeneinheitService.readMengeneinheiten(betriebId).pipe(
          map(mengeneinheitDtos => {
            this._logger.debug('read mengeneinheit succeeded.');
            return MengeneinheitEntitiesActions.readMengeneinheitSuccess({
              betriebId,
              mengeneinheitDtos: mengeneinheitDtos as MengeneinheitExtended[],
            });
          }),
          catchError(error =>
            of(error).pipe(
              mappedHttpErrorResponseOperator(error),
              switchMap(error => {
                this._logger.error('read mengeneinheit failed.', 'error:', error);
                return [MengeneinheitEntitiesActions.readMengeneinheitFailed({error})];
              })
            )
          )
        )
      )
    )
  );

}
